import { createAction, props } from '@ngrx/store';

export const setPresetOptionList = createAction(
  '[PresetOption] Set CampaignOption List',
  props<any>()
);

export const setPresetOptionListSuccess = createAction(
  '[PresetOption] Set CampaignOption List Success',
  props<any>()
);

export const setPresetOptionListFailure = createAction(
  '[PresetOption] Set CampaignOption List Failure',
  props<any>()
);

export const resetPresetOptionList = createAction(
  '[PresetOption] Reset CampaignOption List',
  props<any>()
);

export const resetPresetOptionListSuccess = createAction(
  '[PresetOption] Reset CampaignOption List Success',
  props<any>()
);

export const resetPresetOptionListFailure = createAction(
  '[PresetOption] Reset CampaignOption List Failure',
  props<any>()
);

export const createPresetOption = createAction(
  '[PresetOption] Create CampaignOption',
  props<any>()
);

export const createPresetOptionSuccess = createAction(
  '[PresetOption] Create CampaignOption Success',
  props<any>()
);

export const createPresetOptionFailure = createAction(
  '[PresetOption] Create CampaignOption Failure',
  props<any>()
);

export const updatePresetOption = createAction(
  '[PresetOption] Update CampaignOption',
  props<any>()
);

export const updatePresetOptionSuccess = createAction(
  '[PresetOption] Update CampaignOption Success',
  props<any>()
);

export const updatePresetOptionFailure = createAction(
  '[PresetOption] Update CampaignOption Failure',
  props<any>()
);

export const deletePresetOption = createAction(
  '[PresetOption] Delete CampaignOption',
  props<any>()
);

export const deletePresetOptionSuccess = createAction(
  '[PresetOption] Delete CampaignOption Success',
  props<any>()
);

export const deletePresetOptionFailure = createAction(
  '[PresetOption] Delete CampaignOption Failure',
  props<any>()
);

export const selectPresetOption = createAction(
  '[PresetOption] Select CampaignOption',
  props<any>()
);

export const selectPresetOptionSuccess = createAction(
  '[PresetOption] Select CampaignOption Success',
  props<any>()
);

export const selectPresetOptionFailure = createAction(
  '[PresetOption] Select CampaignOption Failure',
  props<any>()
);

export const unselectPresetOption = createAction(
  '[PresetOption] Unselect CampaignOption',
  props<any>()
);

export const unselectPresetOptionSuccess = createAction(
  '[PresetOption] Unselect CampaignOption Success',
  props<any>()
);

export const unselectPresetOptionFailure = createAction(
  '[PresetOption] Unselect CampaignOption Failure',
  props<any>()
);